import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  titles: {
    draft: 'Comanda dvs. (cost pe lună)',
    main: 'Abonamentul dvs.',
    billing_settings: 'Setări de facturare',
  },
  form: {
    billing_mode: {
      label: 'Mod de facturare',
    },
    has_trial: {
      label: 'Adaugă zile de probă gratuite',
    },
    trial_days: {
      label: 'Câte zile de probă ar trebui să fie?',
      placeholder: '21',
      validation: {
        required: 'Zilele de probă sunt obligatorii',
        min: '{{value}} este valoarea minimă pentru zilele de probă',
        max: '{{value}} este valoarea maximă pentru zilele de probă',
      },
    },
  },
  fields: {
    created_at: 'Creat pe <strong>{{date}}</strong> de <strong>{{manager}}</strong>',
    updated_at: 'Ultima actualizare pe <strong>{{date}}</strong> de <strong>{{manager}}</strong>',
    trial_ends_at: 'În perioadă de probă până pe <strong>{{date}}</strong>',
    trial_days:
      'Perioada de probă de {{trialDays}} zile începe la data lansării, veți fi facturat după expirarea acesteia',
    resumable_until: 'Reactivabil până pe <strong>{{date}}</strong>',
    ended_at: 'Încheiat pe <strong>{{date}}</strong>',
    next_bill_at: 'Următoarea factură pe <strong>{{date}}</strong>',
    product: 'Produs',
    quantity: 'Cantitate',
    price: 'Preț net',
    tax: 'Taxă',
    amount: 'Sumă',
    net: 'Net',
    tax_percentage: 'Taxă {{rate}}%',
    total: 'Total perceput pe lună',
  },
  billing_modes: {
    [BillingMode.Stripe]: 'Percepere din metoda de plată',
    [BillingMode.InternalInvoicing]: 'Percepere din vânzări',
  },
  labels: {
    included: 'inclus',
    sales_based_discount:
      'Există un articol în coș cu preț variabil; prețul actual va fi calculat la crearea/actualizarea abonamentului pe baza vânzărilor din luna anterioară',
  },
  buttons: {
    edit: 'Editează',
    cancel: 'Anulează',
    resume: 'Reactivează',
  },
  modals: {
    cancel_subscription: {
      title: 'Anulați abonamentul {{company}}?',
      description:
        'Această acțiune va anula abonamentul selectat, inclusiv <strong>{{products}}</strong> (<strong>{{total}} suma totală</strong>). Abonamentul rămâne activ și poate fi reluat până la <strong>{{endsAt}}</strong>. Dacă nu este reluat până atunci, trebuie creat un abonament nou.',
    },
    resume_subscription: {
      title: 'Reactivați abonamentul {{company}}?',
      description:
        'Această acțiune va relua abonamentul selectat, inclusiv <strong>{{products}}</strong>. Restaurantului i se percep <strong>{{total}}</strong> în fiecare lună, următoarea plată fiind pe <strong>{{nextBillingDate}}</strong>.',
      description_prorated:
        'Această acțiune va relua abonamentul selectat, inclusiv <strong>{{products}}</strong>. Prima plată din <strong>{{nextBillingDate}}</strong> este calculată proporțional până pe data de 5. De atunci, restaurantului i se percep <strong>{{total}}</strong> pe 5 ale fiecărei luni.',
    },
  },
  toasts: {
    cancel_subscription:
      'Dacă doriți să anulați abonamentul, contactați persoana de contact {{provider}} prin telefon sau e-mail. Aceasta va anula abonamentul imediat.',
    failed_to_cancel_subscription:
      'Ceva a mers greșit la anularea abonamentului. Vă rugăm să contactați suportul tehnic',
    resume_subscription:
      'Dacă doriți să reactivați abonamentul, contactați persoana de contact {{provider}} prin telefon sau e-mail. Aceasta va reactiva abonamentul imediat.',
    failed_to_resume_subscription:
      'Ceva a mers greșit la reactivarea abonamentului. Vă rugăm să contactați suportul tehnic',
  },
};
